import { gql } from "@apollo/client";

export const GET_PLATFORM_EVENT_LOGS = gql`
  query platformEventLogs(
    $selectedCompanyId: ID
    $resourceId: ID
    $startDate: Float
    $endDate: Float
    $service: EventLogService
    $first: Int
    $after: String
  ) {
    platformEventLogs(
      selectedCompanyId: $selectedCompanyId
      resourceId: $resourceId
      startDate: $startDate
      endDate: $endDate
      service: $service
      first: $first
      after: $after
    ) {
      edges {
        cursor
        node {
          id
          eventType
          service
          dataType
          occurredAt
          actor {
            id
            firstName
            lastName
            email
            apiKeyName
          }
          eventData
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;
